import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RecursosHidricosRoutingModule } from './recursos-hidricos-routing.module';
import { NgxLoadingModule } from 'ngx-loading';

@NgModule({
	imports: [CommonModule, RecursosHidricosRoutingModule, NgxLoadingModule],
})
export class RecursosHidricosModule {}
